<script setup lang="ts">
import { computed } from 'vue';

// PROPS
const props = defineProps<{
  text: string;
}>();

// COMPUTED
const formattedText = computed(() => props.text?.replace(/\n/g, '<br>') ?? '');
</script>
<template>
  <div v-html="formattedText"></div>
</template>
